<template>
  <div>
    <div class="banner">
      <div class="w">
        <div class="li-1">
          <img src="../../assets/img/pagess/gdd128/logo.png" alt="" />
          <span>投资有风险 入市需谨慎</span>
        </div>
        <div class="li-2">2022全新官版炒股软件</div>
        <div class="li-3">一键注册选股更轻松 实时提示股票信号</div>
        <div class="li-4">
          <div class="l">
            <div class="main">
              <div class="red btns">
                <img src="../../assets/img/pagess/gdd128/red.png" alt="" />
              </div>
              <div class="green btns">
                <img src="../../assets/img/pagess/gdd128/green.png" alt="" />
              </div>
            </div>
          </div>
          <div class="r">
            <div class="lis1">全新电脑版授权下载中心</div>
            <div class="lis2 btn" @click="to_xaizai()">
              <img src="../../assets/img/pagess/gdd128/btn1.png" alt="" />
            </div>
            <div class="lis3">1键安装，3秒注册，免费使用</div>
          </div>
        </div>
      </div>
    </div>
    <div class="h1">
      <div class="w">
        <div class="li-1">赢在开盘前：潜力龙头提前挖掘</div>
        <div class="li-2">
          <div class="left">
            <div class="lis1">盘前快速选股</div>
            <div class="lis2">
              根据沪深将近4000只个股的深度资料进行挖掘，通过现代化的数据分析系统，将股票按照超跌板、趋势板、放量板等方向进行分类
            </div>
            <div class="lis3 btn" @click="to_xaizai()">
              <img src="../../assets/img/pagess/gdd128/btn1.png" alt="" />
            </div>
            <div class="lis4">直接进入查看并选择</div>
          </div>
          <div class="right">
            <img src="../../assets/img/pagess/gdd128/h1-1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="h2">
      <div class="w">
        <div class="lis1">
          <div class="left">
            <img src="../../assets/img/pagess/gdd128/h2-1.png" alt="" />
          </div>
          <div class="right">
            <div class="liss1">把握趋势，波段为王</div>
            <div class="liss2">
              <span>B信号： </span>B信号提示行情机会，辅助决策
            </div>
            <div class="liss3">
              <span>S信号： </span>S信号提示行情风险，辅助决策
            </div>
            <div class="liss4 btn" @click="to_xaizai()">
              <img src="../../assets/img/pagess/gdd128/btn1.png" alt="" />
            </div>
            <div class="liss5">根据软件提示，把握个股趋势</div>
          </div>
        </div>
        <div class="lis2">
          以上功能均出自股多多股票软件相关渠道。因市场存在不确定性，产品具有局限性，历史收益不代表未来收益，仅供参考。投资有风险，入市需谨慎
        </div>
      </div>
    </div>
    <div class="h3">
      <div class="w">
        <div class="li-1">
          <div class="left">
            <div class="lis1">股票信号提示</div>
            <div class="lis2"><span>B点：</span> -- 提示机会</div>
            <div class="lis3"><span>S点：</span> -- 提示风险</div>
            <div class="lis4">
              明日的行情涨跌，永远是我们关心的问题。软件给你提供参
              考信号，让你与机会更近一步
            </div>
            <div class="lis5 btn" @click="to_xaizai()">
              <img src="../../assets/img/pagess/gdd128/btn1.png" alt="" />
            </div>
            <div class="lis6">实时提示个股信号，把握大时机</div>
          </div>
          <div class="right">
            <img src="../../assets/img/pagess/gdd128/h3-1.png" alt="" />
          </div>
        </div>
        <div class="li-2">
          以上功能均出自股多多股票软件相关渠道。因市场存在不确定性，产品具有局限性，历史收益不代表未来收益，仅供参考。投资有风险，入市需谨慎
        </div>
      </div>
    </div>
    <div class="bottomss">
      <div class="boxx"></div>
      <p style="padding-top: 50px">————&nbsp;投资有风险入市需谨慎&nbsp;————</p>
      <p>
        从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp;
        合法机构名单可到中国证监会网站 (<a href="http://www.csrc.gov.cn/"
          >www.csrc.gov.cn</a
        >)查询
      </p>
      <p>
        北京天相财富管理顾问有限公司 &nbsp;&nbsp;&nbsp;
        <a href="https://beian.miit.gov.cn/">京ICP备16068579号-1</a
        >&nbsp;&nbsp;&nbsp; 执证编号：91110102MA001GJE1N
      </p>
      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年2月</p>
      <p style="text-decoration: underline; cursor: pointer" class="qwer">
        <span @click="open_yinsi()" style="margin-right: 10px"
          >隐私保护政策</span
        >
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>
      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
    <div class="bar">
      <div class="w">
        <div class="li-1">
          <p>股多多龙头短线王 <span>新手也能轻松掌握</span> 的炒股软件</p>
          <img
            class="btn"
            @click="to_xaizai()"
            src="../../assets/img/pagess/gdd128/btn2.png"
            alt=""
          />
        </div>
        <div class="li-2">
          以上功能均出自股多多股票软件相关渠道。因市场存在不确定性，产品具有局限性，历史收益不代表未来收益，仅供参考。投资有风险，入市需谨慎
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: false
    };
  },
  mounted() {
    this.clientIp();
    // 滚动条的获取
    // window.addEventListener("scroll", this.handleScrollx, true);
  },
  methods: {
    // open_yinsi() {
    //   window.open("https://ins.juniubang.com/images/隐私政策（河北）4.7.pdf");
    // },
    // open_fuwuxieyi() {
    //   window.open(
    //     "https://ins.juniubang.com/images/%E5%BA%94%E7%94%A8%E6%9D%83%E9%99%904.7(%E6%B2%B3%E5%8C%97).pdf"
    //   );
    // },
    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },
    changebar(index) {
      this.active = index;
    },
    to_xaizai() {
      this.post_leilei_data();
      // window.open("https://cdn.juniubang.com/apk/GDD2001.exe");
      // window.open("https://cdn.juniubang.com/apk/GDD2001.exe");
      this.message = "";
    },
    // 给磊磊传页面数据
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          qhclickid: this.$route.query.sourceid,
          url: window.location.href,
          code: this.$route.query.code,
          type: "360"
        })
        .then(res => { window.open(res.data.message);});
    },

    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().top < 1000) {
        this.res = true;
      } else {
        this.res = false;
      }
    },
    clientIp() {
      this.$http.post("/client_ip", { url: window.location.href }).then(res => {
        window.localStorage.setItem("_number", res.data);
      });
    }
    // post_data() {
    //   this.$http
    //     .post("/to_api", {
    //       qhclickid: this.$route.query.qhclickid,
    //       trans_id: this.$route.query.qhclickid,
    //     })
    //     .then((res) => {
    //
    //     });
    // },
  }
};
</script>
<style lang="less" scoped>
.bottomss {
  width: 100%;
  height: 608px;
  background: url(../../assets/img/pagess/gdd128/bottomss.png) no-repeat center;
  color: #fff;
  text-align: center;
  p {
    margin: 20px 0;
  }
  a:hover {
    color: #bc1102;
  }
}
.btns {
  animation-duration: 1s; /*动画时间*/

  animation-fill-mode: both; /*播放后的状态*/

  animation-name: buzz-out;

  animation-iteration-count: infinite; /*动作循环的次数：infinite 无限循环*/

  transform-origin: center bottom; /*设置动画旋转元素的基点为：居中靠下*/

  cursor: pointer;
}

@-webkit-keyframes buzz-out {
  0%,
  100%,
  20%,
  50%,
  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);

    /*贝塞尔曲线 ： X1 Y1 X2 Y2*/

    transform: translate3d(0, 0, 0); /*设置只在Z轴上移动*/
  }

  40%,
  43% {
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);

    transform: translate3d(0, -30px, 0);
  }

  70% {
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);

    transform: translate3d(0, -15px, 0);
  }

  90% {
    transform: translate3d(0, -4px, 0);
  }
}

p {
  margin: 0;
  padding: 0;
}
.w {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}
.banner {
  width: 100%;
  height: 760px;
  background: url(../../assets/img/pagess/gdd128/banner.png) no-repeat center;
  .w {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .li-1 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 38px;
    span {
      color: rgba(21, 25, 28, 1);
      font-size: 24px;
      font-weight: 400;
    }
  }
  .li-2 {
    margin-top: 25px;
    color: rgba(188, 17, 2, 1);
    font-size: 108px;
    font-weight: 700;
  }
  .li-3 {
    color: rgba(21, 25, 28, 1);
    font-size: 42px;
    font-weight: 400;
  }
  .li-4 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 20px;
    .l {
      width: 598px;
      height: 391px;
      background: url(../../assets/img/pagess/gdd128/banner-computer.png)
        no-repeat center;
      .main {
        width: 10px;
        margin: 0 auto;
        position: relative;
        .red {
          position: absolute;
          top: 260px;
          left: -180px;
        }
        .green {
          position: absolute;
          top: 40px;
          left: 168px;
        }
      }
    }
    .r {
      display: flex;
      flex-direction: column;
      align-items: center;
      .lis1 {
        color: rgba(21, 25, 28, 1);
        font-size: 36px;
        font-weight: 400;
      }
      .lis2 {
        margin-top: 30px;
        margin-bottom: 10px;
      }
      .lis3 {
        color: rgba(21, 25, 28, 1);
        font-size: 21px;
        font-weight: 400;
      }
    }
  }
}
.h1 {
  width: 100%;
  height: 680px;
  background: rgba(255, 255, 255, 1);
  .w {
    display: flex;
    flex-direction: column;
    align-items: center;

    .li-1 {
      width: 910px;
      white-space: nowrap;
      height: 91px;
      color: rgba(188, 17, 2, 1);
      font-size: 66px;
      font-weight: 600;
      padding-top: 49px;
    }
    .li-2 {
      margin-top: 50px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        width: 527px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .lis1 {
          color: rgba(188, 17, 2, 1);
          font-size: 42px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .lis2 {
          width: 527px;
          line-height: 1.5;
          color: rgba(21, 25, 28, 1);
          font-size: 20px;
          font-weight: 400;
          margin-bottom: 32px;
        }
        .lis4 {
          color: rgba(21, 25, 28, 1);
          font-size: 21px;
          font-weight: 400;
          margin-top: 10px;
        }
      }
    }
  }
}
.h2 {
  width: 100%;
  height: 680px;
  background: rgba(255, 249, 240, 1);
  .w {
    display: flex;
    flex-direction: column;
    align-items: center;
    .lis1 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 110px;
      .right {
        width: 527px;
        display: flex;
        align-items: center;
        flex-direction: column;

        .liss1 {
          color: rgba(188, 17, 2, 1);
          font-size: 42px;
          font-weight: 500;
          margin-bottom: 34px;
        }
        .liss2 {
          color: rgba(21, 25, 28, 1);
          font-size: 20px;
          font-weight: 400;
          margin-bottom: 22px;
          span {
            color: #bc1102;
          }
        }
        .liss3 {
          color: rgba(21, 25, 28, 1);
          font-size: 20px;
          font-weight: 400;
          margin-bottom: 35px;
          span {
            color: #04e60a;
          }
        }
        .liss5 {
          margin-top: 10px;
        }
      }
    }
    .lis2 {
      color: rgba(21, 25, 28, 1);
      font-size: 14px;
      font-weight: 400;
      margin-top: 102px;
    }
  }
}
.h3 {
  width: 100%;
  height: 680px;
  background: rgba(255, 255, 255, 1);

  .w {
    // background-color: green;
    padding-top: 101px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    .li-1 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        width: 527px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .lis1 {
          color: rgba(188, 17, 2, 1);
          font-size: 42px;
          font-weight: 500;
          margin-bottom: 34px;
        }
        .lis2 {
          color: rgba(21, 25, 28, 1);
          font-size: 20px;
          font-weight: 400;
          margin-bottom: 10px;
          span {
            color: #bc1102;
          }
        }
        .lis3 {
          color: rgba(21, 25, 28, 1);
          font-size: 20px;
          font-weight: 400;
          margin-bottom: 20px;
          span {
            color: #04e60a;
          }
        }
        .lis4 {
          color: rgba(21, 25, 28, 1);
          font-size: 20px;
          font-weight: 400;
          text-align: center;
          margin-bottom: 30px;
        }
        .lis5 {
          margin-bottom: 10px;
        }
      }
    }
    .li-2 {
      margin-top: 102px;
      color: rgba(21, 25, 28, 1);
      font-size: 14px;
      font-weight: 400;
    }
  }
}
.bar {
  width: 100%;
  height: 180px;
  background: rgba(0, 0, 0, 0.5);
  // background-color: red;
  position: fixed;
  bottom: 0;
  .w {
    display: flex;
    flex-direction: column;
    align-items: center;
    .li-1 {
      margin-bottom: 27px;
      display: flex;
      align-items: center;
      padding-top: 20px;
      p {
        color: #fff;
        font-size: 26px;
        font-weight: 400;
        margin-right: 20px;
        span {
          font-size: 35px;
          font-weight: 600;
          color: #bc1102;
        }
      }
    }
    .li-2 {
      color: #fff;
    }
  }
}

// .box {
//   height: 280px;
//   background-color: #fff;
// }
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd141.vue